import { CampaignPageAdapter } from '@fmnts/api/next';
import { Adapter } from '@fmnts/core';
import { SelfCheckout } from '@formunauts/self-checkout/domain';
export class AuthenticationFormAdapter
  implements Adapter<SelfCheckout.AuthenticationForm, Record<string, any>>
{
  private campaignPageAdapter = new CampaignPageAdapter();
  adapt(value: Record<string, any>): SelfCheckout.AuthenticationForm {
    return SelfCheckout.AuthenticationForm({
      organizationLogo: value['organization_logo'],
      language: value['language'],
      form: this.campaignPageAdapter.adapt(value['form']),
      style: value['style'],
      locale: value['locale'],
    });
  }
}

export class SelfCheckoutFormAdapter
  implements Adapter<SelfCheckout.SelfCheckoutForm, Record<string, any>>
{
  private campaignPageAdapter = new CampaignPageAdapter();
  adapt(value: Record<string, any>): SelfCheckout.SelfCheckoutForm {
    return SelfCheckout.SelfCheckoutForm({
      organizationLogo: value['organization_logo'],
      language: value['language'],
      form: this.campaignPageAdapter.adapt(value['form']),
      style: value['style'],
      locale: value['locale'],
    });
  }
}
export class UnsubscribeFormAdapter
  implements Adapter<SelfCheckout.UnsubscribeForm, Record<string, any>>
{
  private campaignPageAdapter = new CampaignPageAdapter();
  adapt(value: Record<string, any>): SelfCheckout.UnsubscribeForm {
    return SelfCheckout.UnsubscribeForm({
      organizationLogo: value['organization_logo'],
      language: value['language'],
      form: this.campaignPageAdapter.adapt(value['form']),
      style: value['style'],
      locale: value['locale'],
    });
  }
}

export class CheckoutResponseDefaultAdapter
  implements
    Adapter<
      SelfCheckout.SelfCheckoutResponseDefault,
      {
        response: Record<string, any>;
        status: SelfCheckout.DonationStatus;
      }
    >
{
  adapt(value: {
    response: Record<string, any>;
    status: SelfCheckout.DonationStatus;
  }): SelfCheckout.SelfCheckoutResponseDefault {
    return { status: value.status } as SelfCheckout.SelfCheckoutResponseDefault;
  }
}

export class CheckoutResponseTamaroAdapter
  implements
    Adapter<
      SelfCheckout.SelfCheckoutResponseTamaro,
      {
        response: Record<string, any>;
        status: SelfCheckout.DonationStatus;
      }
    >
{
  adapt(value: {
    response: Record<string, any>;
    status: SelfCheckout.DonationStatus;
  }): SelfCheckout.SelfCheckoutResponseTamaro {
    const tamaro: SelfCheckout.TamaroInstance | undefined =
      value.response &&
      (value.response['raisenow_tamaro_instance'] ||
        value.response['raisenow_tamaro_config'])
        ? {
            instance: value.response['raisenow_tamaro_instance'],
            config: value.response['raisenow_tamaro_config'],
          }
        : undefined;
    if (!tamaro) {
      throw new Error('Missing tamaro instance or config in the response');
    }

    return { tamaro: tamaro } as SelfCheckout.SelfCheckoutResponseTamaro;
  }
}
